import React, { useState } from "react";
import moment from "moment";
import {
  batchAssignTokens,
  transfer,
  stake,
  canUnlock,
  unlock,
  getStakeDetails,
} from "src/hooks/operations";
import {
  Container,
  Box,
  TextField,
  makeStyles,
  Button,
  Grid,
  Card,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Dialog,
  DialogContent,
  OutlinedInput,
  InputAdornment
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: -80,
  },
}));

export default function Form({ userData, ownerId, refreshPage, allData }) {
  const { account } = userData;
  // console.log("all Data", allData);
  const classes = useStyle();
  const [tier, setTier] = useState("");
  const [addAllocate, setAddAllocate] = useState("");
  const [amountAllocate, setAmountAllocate] = useState("");
  const [submitAllocate, setSubmitAllocate] = useState(false);
  const [isLoadingAllocate, setIsLoadingAllocate] = useState(false);
  const [errorAllocate, setErrorAllocate] = useState("");
  const [submitTransfer, setSubmitTransfer] = useState(false);
  const [isLoadingTransfer, setIsLoadingTransfer] = useState(false);
  const [errorTransfer, setErrorTransfer] = useState("");
  const [addTransfer, setAddTransfer] = useState("");
  const [amountTransfer, setAmountTransfer] = useState("");
  const [stakeDetails, setStakeDetails] = useState(false);
  const [isLoadingStake, setIsLoadingStake] = useState(false);
  const [stakeValue, setStakeValue] = useState("")
  const [stakeDetailsData, setStakeDetailsData] = useState({});
  const [canUnlockStatus, setCanUnlockStatus] = useState({
    clicked: false,
    status: false,
  });
  const [statusState, setStatusState] = useState({
    unlock: false,
    stake: false,
  });
  const allocateCurrency = async () => {
    setErrorAllocate("");
    if ((tier === "" || addAllocate === "", amountAllocate === "")) {
      setSubmitAllocate(true);
    } else {
      setIsLoadingAllocate(true);
      const allAddress = addAllocate.split(",").filter(function (entry) {
        return entry.trim() !== "";
      });
      let finalData = {
        address: [],
        amount: [],
        tier: [],
      };
      allAddress.forEach((address) => {
        const finalAddress = address.replace(/\s+/g, "");
        finalData = {
          address: [...finalData.address, finalAddress],
          amount: [...finalData.amount, amountAllocate],
          tier: [...finalData.tier, tier],
        };
      });
      // console.log(finalData);
      const res = await batchAssignTokens(finalData);
      setErrorAllocate(res);
      refreshPage();
      setTimeout(() => {
        setErrorAllocate("");
      }, 5000);
      setIsLoadingAllocate(false);
    }
  };

  const transferToken = async () => {
    setErrorTransfer("");
    if (addTransfer === "" || amountTransfer === "") {
      setSubmitTransfer(true);
    } else {
      setIsLoadingTransfer(true);
      const res = await transfer(addTransfer, amountTransfer);
      setErrorTransfer(res);
      refreshPage();
      setTimeout(() => {
        setErrorTransfer("");
      }, 5000);
      setIsLoadingTransfer(false);
    }
  };

  const on_Staking = async () => {
    setIsLoadingStake(true);
    const res = await stake(account, stakeValue);
    // console.log(res);
    if (res) {
      refreshPage();
    }
    setIsLoadingStake(false);
  };

  const on_canUnlock = async () => {
    const status = await canUnlock(account);
    setCanUnlockStatus({
      clicked: true,
      status: status,
    });
  };

  const on_unlock = async () => {
    setStatusState({
      ...statusState,
      unlock: true,
    });
    try {
      const res = await unlock(account);
    } catch (error) {}
    setStatusState({
      ...statusState,
      unlock: false,
    });
  };
  const on_getStakeDetails = async () => {
    const res = await getStakeDetails(account);
    setStakeDetailsData(res);
    setStakeDetails(true);
    // console.log(res);
  };

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        <Card
          elevation={0}
          style={{ boxShadow: "0 0 2rem 0 rgb(136 152 170 / 15%)" }}
        >
          {ownerId.toUpperCase() === account.toUpperCase() && (
            <Box p={5}>
              <Typography variant="h3" paragraph>
                Allocate Currency
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Address"
                    fullWidth
                    variant="outlined"
                    value={addAllocate}
                    onChange={(e) => setAddAllocate(e.target.value)}
                    error={submitAllocate && addAllocate === ""}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Amount"
                    fullWidth
                    variant="outlined"
                    value={amountAllocate}
                    onChange={(e) => setAmountAllocate(e.target.value)}
                    type="number"
                    error={submitAllocate && amountAllocate === ""}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    error={submitAllocate && tier === ""}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Tier
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={tier}
                      onChange={(e) => setTier(e.target.value)}
                      label="Tier"
                    >
                      <MenuItem value={0}>Strategic Sale</MenuItem>
                      <MenuItem value={1}>Private Sale 1</MenuItem>
                      <MenuItem value={2}>Private Sale 2</MenuItem>
                      <MenuItem value={3}>Public Sale</MenuItem>
                      <MenuItem value={4}>Airdrop</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    color="primary"
                    onClick={allocateCurrency}
                    disabled={isLoadingAllocate}
                  >
                    {isLoadingAllocate ? "Pending" : "Submit"}
                  </Button>
                </Grid>
              </Grid>
              {errorAllocate !== "" && (
                <Box pt={1}>
                  {errorAllocate === "Done" ? (
                    <Typography variant="body2" style={{ color: "green" }}>
                      Currency Allocated Successfully
                    </Typography>
                  ) : (
                    <Typography color="error" variant="body2">
                      {errorAllocate}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          )}
          <Box p={5}>
            <Typography variant="h3" paragraph>
              Transfer Token
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Address"
                  fullWidth
                  variant="outlined"
                  value={addTransfer}
                  onChange={(e) => setAddTransfer(e.target.value)}
                  error={submitTransfer && addTransfer === ""}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Amount"
                  fullWidth
                  variant="outlined"
                  value={amountTransfer}
                  onChange={(e) => setAmountTransfer(e.target.value)}
                  type="number"
                  error={submitTransfer && amountTransfer === ""}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  color="primary"
                  onClick={transferToken}
                  disabled={isLoadingTransfer}
                >
                  {isLoadingTransfer ? "Pending" : "Submit"}
                </Button>
              </Grid>
            </Grid>
            {errorTransfer !== "" && (
              <Box pt={1}>
                {errorTransfer === "Done" ? (
                  <Typography variant="body2" style={{ color: "green" }}>
                    Token Transferred Successfully
                  </Typography>
                ) : (
                  <Typography color="error" variant="body2">
                    {errorTransfer}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          {ownerId.toUpperCase() !== account.toUpperCase() && (
            <Box style={{ padding: "0 40px 40px" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                <FormControl variant="outlined" fullWidth>
          <InputLabel htmlFor="outlined-adornment-password">Stake value</InputLabel>
          <OutlinedInput
          id="outlined-adornment-password"
            type="text"
            value={stakeValue}
            onChange={(e)=>setStakeValue(e.target.value)}
            disabled={
              isLoadingStake ||
              !allData ||
              allData.stakeAmount > "0.0"
            }
            endAdornment={
              <InputAdornment position="end">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    disabled={
                      isLoadingStake ||
                      !allData ||
                      allData.stakeAmount > "0.0"
                    }
                    onClick={on_Staking}
                  >
                    {isLoadingStake ? "Pending..." : "Stake"}
                  </Button>
              </InputAdornment>
            }
            labelWidth={95}
            style={{paddingRight:0}}
          />
          </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={6} lg={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    disabled={
                      isLoadingStake ||
                      !allData ||
                      allData.unlockedBalanceOf === "0.0"
                    }
                    onClick={on_Staking}
                  >
                    {isLoadingStake ? "Pending..." : "Stake"}
                  </Button>
                </Grid>*/}
                <Grid item xs={12} sm={6} lg={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={on_getStakeDetails}
                  >
                    Stake Details
                  </Button>
                </Grid> 
                <Grid item xs={12} sm={6} lg={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={on_canUnlock}
                  >
                    Can Unlock &nbsp;
                    {canUnlockStatus.clicked && canUnlockStatus.status && (
                      <CheckCircleIcon style={{ color: "#fff" }} />
                    )}
                    {canUnlockStatus.clicked && !canUnlockStatus.status && (
                      <CancelIcon color="secondary" />
                    )}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} lg={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    onClick={on_unlock}
                    disabled={
                      statusState.unlock || !allData || !allData.canUnlock
                    }
                  >
                    {statusState.unlock ? "Pending..." : "Unlock"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </Card>
      </Container>

      {stakeDetails && (
        <Dialog
          open={stakeDetails}
          onClose={() => setStakeDetails(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Box p={2} pt={1}>
              <Typography variant="h4" color="primary" gutterBottom>
                Stake Details
              </Typography>
              <Typography>
                Stake Amount: <strong>{stakeDetailsData.stakeAmount}</strong>
              </Typography>
              <Typography>
                Start Time:{" "}
                <strong>
                  {moment.unix(stakeDetailsData.startTime).format("MMM Do YYYY")}
                </strong>
              </Typography>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}
